var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilRig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 59",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "037---Oil-Rig",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 36.792h-4v-20.584h16v20.584h-7z",
    fill: "#e64c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m34.5 22-1.5-6h-6l-1.5 6-1.75 7-1.75 7h16l-1.75-7z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4 12c-.55228475 0-1-.4477153-1-1v-7c0-.55228475.44771525-1 1-1s1 .44771525 1 1v7c0 .5522847-.44771525 1-1 1z",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m18 12c-.5522847 0-1-.4477153-1-1v-7c0-.55228475.4477153-1 1-1s1 .44771525 1 1v7c0 .5522847-.4477153 1-1 1z",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m56 42c-.5522847 0-1-.4477153-1-1v-27c0-.5522847.4477153-1 1-1s1 .4477153 1 1v27c0 .5522847-.4477153 1-1 1z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35.09 24.36 18.67-14.67c1.2778468-.99512853 3.0938041-.89565416 4.2553092.233097 1.1615051 1.1287512 1.3128697 2.9411211.3546908 4.246903l-16.37 21.83h-6z",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m19 36h31c.5522847 0 1 .4477153 1 1v5.5h-48v-6.5z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m34 8c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4c0-3 4-3.5 2-7.5-.988-1.976 6 2.5 6 7.5z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#bdc3c7",
    height: 4,
    rx: 1,
    width: 8,
    x: 26,
    y: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 36h-16l14.25-7z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36.25 29-14.25 7 1.75-7z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36.25 29h-12.5l1.75-7z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36.25 29-10.75-7h9z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m34.5 22h-9l1.5-6h6z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m20 17h-17l-1.636-5.725c-.08633341-.3018353-.02591073-.6266936.16317552-.8773017.18908624-.2506081.48488503-.39787279.79882448-.3976983h17.674c.5522847 0 1 .4477153 1 1v5c0 .5522847-.4477153 1-1 1z",
    fill: "#c03a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m14 21h5v6h-5c-.5522847 0-1-.4477153-1-1v-4c0-.5522847.4477153-1 1-1z",
    fill: "#2fa8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4 21h5v6h-5c-.55228475 0-1-.4477153-1-1v-4c0-.5522847.44771525-1 1-1z",
    fill: "#2fa8cc",
    transform: "matrix(-1 0 0 -1 12 48)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3f5c6c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10 5h2c1.1045695 0 2 .8954305 2 2v3h-6v-3c0-1.1045695.8954305-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m15 46v11.97c-3.14-.34-3.3-3.97-6.75-3.97-.80469947-.0180405-1.59375873.2239377-2.25.69v-8.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 46v8.7c-.6529374-.4737707-1.4435283-.7197324-2.25-.7-3.45 0-3.62 3.61-6.75 3.97v-11.97z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 59c-1.7401229-.0495407-3.3566395-.9110907-4.368-2.328-.847-.934-1.516-1.672-2.886-1.672s-2.04.738-2.888 1.672c-.9764711 1.4550667-2.6136545 2.3280498-4.366 2.3280498s-3.3895289-.8729831-4.366-2.3280498c-.846-.934-1.515-1.672-2.884-1.672s-2.038.738-2.885 1.671c-1.0105158 1.4174927-2.6268905 2.2795346-4.367 2.329-1.7392201-.0498518-3.3546925-.9114371-4.365-2.328-.846-.934-1.515-1.672-2.884-1.672s-2.036.737-2.882 1.671c-1.0097783 1.417302-2.6254786 2.2793789-4.365 2.329-1.7392891-.0494666-3.3547492-.9116129-4.364-2.329-.846-.933-1.514-1.671-2.883-1.671s-2.036.737-2.882 1.671c-1.0097783 1.417302-2.62547856 2.2793789-4.365 2.329-.55228475 0-1-.4477153-1-1s.44771525-1 1-1c1.369 0 2.037-.738 2.883-1.671 1.00925085-1.4173871 2.62471092-2.2795334 4.364-2.329 1.73952144.0496211 3.3552217.911698 4.365 2.329.846.934 1.514 1.671 2.882 1.671s2.037-.738 2.883-1.671c1.0092508-1.4173871 2.6247109-2.2795334 4.364-2.329 1.739836.0494659 3.3559058.9115425 4.366 2.329.846.934 1.515 1.671 2.883 1.671s2.038-.738 2.885-1.671c.9763998-1.4554973 2.6138366-2.328795 4.3665-2.328795s3.3901002.8732977 4.3665 2.328795c.846.934 1.515 1.671 2.883 1.671s2.039-.738 2.886-1.671c.9773308-1.4554666 2.6153433-2.3285972 4.3685-2.3285972s3.3911692.8731306 4.3685 2.3285972c.847.933 1.516 1.671 2.886 1.671.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#547580",
    height: 6,
    rx: 2,
    width: 58,
    x: 1,
    y: 41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilRig);
export default __webpack_public_path__ + "static/media/oil-rig.6222c799c9c279400a092e73e1e2f88b.svg";
export { ForwardRef as ReactComponent };